import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=79b7aef5&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"
import style0 from "./Items.vue?vue&type=style&index=0&id=79b7aef5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7aef5",
  null
  
)

export default component.exports